import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en";
import zh from "./zh";
import es from "./es";
import th from "./th";
import vi from "./vi";
import fi from "./fi";
import hi from "./hi";

Vue.use(VueI18n);

const messages = {
	en,
	zh,
	es,
    th,
    vi,
    fi,
    hi,
};

const i18n = new VueI18n({
	locale: localStorage.getItem("langue") || "zh", // 默认语言
	messages,
});

export default i18n;
